var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "my7ly-g5hKLqacY7Hxsyda",
    x1: 33.8,
    x2: 33.8,
    y1: 60.11,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6abff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dc7ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#my7ly-g5hKLqacY7Hxsyda)",
    d: "M19.38,9.56l-9.28,8.95L7.01,6L19.38,9.56z M10.6,20.55l2.81,11.39l8.47-8.15L10.6,20.55z M22.44,21.87l-2.49-10.08L12.47,19L22.44,21.87z M13.97,34.19l2.77,11.2l8.31-8.01L13.97,34.19z M15.63,32.58l10.19,2.94 l-2.54-10.29L15.63,32.58z M29.08,48.75l-2.49-10.08l-7.49,7.22L29.08,48.75z M20.37,60.11l9.43-9.07l-12.56-3.61L20.37,60.11z M32.69,13.4l-11.06-3.19l2.75,11.17L32.69,13.4z M25.21,24.73l2.49,10.08l7.49-7.22L25.21,24.73z M35.71,25.66l-2.48-10.02 l-7.45,7.17L35.71,25.66z M36.55,29.06l-7.63,7.35l10.16,2.93L36.55,29.06z M31.34,49.56l8.3-7.98L28.59,38.4L31.34,49.56z M45.99,17.23l-11.09-3.2l2.77,11.22L45.99,17.23z M49.05,29.53l-2.49-10.08l-7.49,7.22L49.05,29.53z M41.3,39.98l8.48-8.16 l-11.29-3.24L41.3,39.98z M48.23,17.87l3.08,12.49l9.28-8.93L48.23,17.87z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "my7ly-g5hKLqacY7Hxsydb",
    x1: 33.8,
    x2: 33.8,
    y1: 61.114,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c822ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a6dff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#my7ly-g5hKLqacY7Hxsydb)",
    d: "M20.374,61.114c-0.093,0-0.187-0.013-0.277-0.04c-0.344-0.099-0.607-0.374-0.693-0.721 L6.036,6.24c-0.086-0.347,0.02-0.712,0.277-0.96c0.257-0.248,0.63-0.339,0.97-0.24l53.586,15.428 c0.344,0.099,0.608,0.374,0.694,0.721c0.086,0.347-0.02,0.713-0.277,0.961L21.067,60.835C20.878,61.017,20.629,61.114,20.374,61.114 z M8.393,7.439L20.93,58.192L58.65,21.909L8.393,7.439z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/threejs.ae7933fdbea708c61ae7f3459f6a01a2.svg";
export { ForwardRef as ReactComponent };